Pegasus.LoadingController = Ember.Controller.extend({
  actions: {
    doneLoading: function(){
      this.send('didLoadEditor');
    }
  }
});
